import { gql } from '@apollo/client'

export const GET_WBS_DATA = gql`
  query GetWBSData {
    WBSData {
      type
      walletType
      showProviderName
      hotels {
        propertyCode
        name {
          fa
          en
        }
        cityName {
          fa
          en
        }
        bookingRedirect
        defaultProviderCode
        defaultRateGroupCode
      }
    }
  }
`
